import {useQuery, UseQueryResult} from '@tanstack/react-query';

import buildrzAxios from 'App/clients/buildrzAxios';
import {autoresultsParams} from 'App/features/project/projectConstants';
import {migrateProject} from 'App/features/project/projectUtils';
import projectQueryKeys from 'App/features/project/queries/keys';
import {Project} from 'Pages/project/project_types';

const useProject = <TData = Project>(
  projectHash: string | null,
  queryParams: Record<string, string | number>,
  select?: (project: Project) => TData,
): UseQueryResult<TData | undefined> =>
  useQuery({
    queryKey: projectQueryKeys.project(projectHash),
    queryFn: async () => {
      const {data} = await buildrzAxios.get<Project>(
        `/projects/${projectHash}/`,
        {
          params: {...queryParams, ...autoresultsParams},
        },
      );
      return migrateProject(data);
    },
    select,
    gcTime: 0,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!projectHash,
  });

export default useProject;
